"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setChallengeName = undefined;

var _ChallengeActionTypes = require("../constants/action-types/ChallengeActionTypes");

var types = _interopRequireWildcard(_ChallengeActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var setChallengeName = exports.setChallengeName = function setChallengeName(challengeName) {
  return {
    type: types.SET_CHALLENGE_NAME,
    payload: {
      challengeName: challengeName
    },
    meta: {
      serverShared: true
    }
  };
};